"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _feedToolz = require("../feed-toolz");

var _CardActionArea = _interopRequireDefault(require("@material-ui/core/CardActionArea"));

var _CardContent = _interopRequireDefault(require("@material-ui/core/CardContent"));

var _radium = _interopRequireDefault(require("radium"));

var _PopularCss = _interopRequireDefault(require("./Popular.css.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CardItem = function CardItem(_ref) {
  var key = _ref.key,
      article = _ref.article,
      styleVariants = _ref.styleVariants;
  var title = article.title,
      link = article.link,
      content = article.content,
      html = article.html;

  var handleLinkClick = function handleLinkClick(e) {
    e.preventDefault();
    window.open(link, '_blank');
  };

  var fullCardTitleStyle = Object.assign({}, _PopularCss.default['cardTitle'], styleVariants['cardTitle']);
  return /*#__PURE__*/_react.default.createElement("div", {
    key: key,
    style: _PopularCss.default.articleCard
  }, /*#__PURE__*/_react.default.createElement(_CardActionArea.default, {
    onClick: handleLinkClick
  }, /*#__PURE__*/_react.default.createElement(_CardContent.default, {
    style: _PopularCss.default.cardBody
  }, /*#__PURE__*/_react.default.createElement("h2", {
    style: fullCardTitleStyle
  }, title), /*#__PURE__*/_react.default.createElement("div", {
    style: _PopularCss.default.cardImageContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: _objectSpread({}, _PopularCss.default.cardImage, {
      backgroundImage: "url(".concat((0, _feedToolz.getSrcFromHtml)(html), ")")
    })
  })), /*#__PURE__*/_react.default.createElement("p", {
    style: _PopularCss.default.cardText
  }, (0, _feedToolz.trimSnippet)(content)))));
};

var _default = (0, _radium.default)(CardItem);

exports.default = _default;

//# sourceMappingURL=CardItem.jsx.map